module.exports = __webpack_public_path__ + "static/img/IMG_20160309_205035.8b47d869.jpg";